<ng-container *transloco="let t">
  @if (notification) {
    @if (notification.favorite) {
      <mat-icon
        color="primary"
        class="favorite-mark"
        [matTooltip]="t('NOTIFICATIONS.FROM_FILTER_FAVORITES')"
        matTooltipClass="custom-tooltip"
      >
        star
      </mat-icon>
    }

    <div class="head">
      <div class="manufacturer-info-wrapper">
        @if (notification.product_master.manufacturer.name; as manufacturer) {
          <h3>
            {{ manufacturer }}
          </h3>
        }

        @if (notification.report_source; as reportSource) {
          <small class="confirmation">
            {{ t('GENERAL.SOURCE') }} {{ reportSource }}
          </small>
        }
      </div>

      <div
        class="date"
        [matTooltip]="
          (notification.created_at | customDate: 'dd.MM.y. HH:mm:ss') ||
          t('GENERAL.INFO.DATE_UNAVAILABLE')
        "
        matTooltipClass="custom-tooltip"
      >
        {{
          (notification.created_at | timeDistance: true) ||
            t('GENERAL.INFO.DATE_UNAVAILABLE')
        }}
      </div>
    </div>

    <div class="body">
      <sandoz-product-status-icon
        [size]="'small'"
        [status]="notification.shortage_status.id"
      ></sandoz-product-status-icon>
      <sandoz-product-status-string
        [productStatus]="notification.shortage_status.id"
      ></sandoz-product-status-string>
      <div class="product-desc">
        {{ notification.product_master.description || '' }}
      </div>
    </div>
  }
</ng-container>
